// New component created by srini on 02-04-25 for engagement section

import { useState, useEffect, useContext } from "react"
import { Grid, IconButton, Button } from "@mui/material"
import { withStyles } from "@material-ui/core/styles"
import { DataGrid } from '@mui/x-data-grid'
import exportFromJSON from 'export-from-json'

import { httpRequest } from "../../../../ui-utils/api"
import { backendHosts, apiUrl } from "../../../../ui-utils/apiConfig"
import snackError from "../../../../helpers/snackError"
import handleStartCall from "../../../../helpers/handleStartCall"

import styles from './engagementStyles'
import { reducerContext } from "../../../../contextApi's/contextApi's";

import CallIcon from '@mui/icons-material/Call'
import DialogBox from "../../../Dialog Box/DialogBox"

const ClientsList = ({ classes }) => {
    const userId = localStorage.getItem('user_id1')
    const { dispatch } = useContext(reducerContext)

    const [engagementList, setEngagementList] = useState([])

    const [dailBoxOpen, setDailBoxOpen] = useState(null)
    // Dailog box bug fixed- srini - 15/04/25
    const [selectedCustNumber, setSelectedCustNumber] = useState(null)

    const handleClickOpen = (phNum) => {
        setDailBoxOpen(true)
        setSelectedCustNumber(phNum)
    }

    const handleClose = () => {
        setDailBoxOpen(false)
    }

    useEffect(() => {
        (async () => {
         
            const franchisee_list = JSON.parse(localStorage.getItem("sipRegData")).franchaise_list || []
         
            try {
                const engagementResult = await httpRequest({
                    endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.ref_engagementList}`,
                    method: "post",
                    instance: "instanceOne",
                    requestBody: { franchisee_list: franchisee_list }
                })

                if (engagementResult.status === 200) {
                    setEngagementList(engagementResult.data)
                } else {
                    dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                    dispatch({ type: 'SET_ERROR', payload: 'Error in fetching Engagement List' })
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                    console.log("Error in fetching Engagement List", engagementResult)
                }
            } catch (error) {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Error in fetching Engagement List' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Error in fetching Engagement List", error)
            }
        })()
    }, [])

    const userColumns = [
        {
            field: 'Call',
            headerName: "Call",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                        <IconButton
                            key={`call-${params.row.mobileno}`}
                            onClick={() => handleClickOpen(params.row.mobileno)}
                            className={classes.cllIcnClr}
                        >
                            <CallIcon style={{ fontSize: '18px' }} />
                        </IconButton>
                        {/* Dailog box bug fixed by srini - 15/04/25 */}
                        <DialogBox
                            open={dailBoxOpen}
                            handleClose={handleClose}
                            customerNumber={selectedCustNumber}
                            dispatch={dispatch}
                            handleStartCall={handleStartCall}
                        />
                    </div>
                );
            }
        },
        {
            field: 'client_id',
            headerName: "Client ID",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            valueFormatter: (params) => {
                return params != null ? params : '-'
            }

        },
        {
            field: 'mobileno',
            headerName: "Mobile No",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            valueFormatter: (params) => {
                return params != null ? params : '-'
            }
        },
        {
            field: 'lasttrade_date',
            headerName: "Last Traded Date",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            valueFormatter: (params) => {
                return params != null ? params : '-'
            }
        },
        {
            field: 'available_margin',
            headerName: "Available Margin",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            valueFormatter: (params) => {
                return params != null ? Number(params).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0
            }
        },
        {
            field: 'profit_notional',
            headerName: "Portfolio PL",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            valueFormatter: (params) => {
                return params != null ? Number(params).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0
            }
        },
        {
            field: 'total_net_brokerage',
            headerName: "Brokerage (FY)",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            valueFormatter: (params) => {
                return params != null ? Number(params).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0
            }
        },
        {
            field: 'lastcall_date',
            headerName: "Call Date",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            valueFormatter: (params) => {
                return params != null ? params : '-'
            }
        },
        {
            field: 'lastcall_disp',
            headerName: "Call Description",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            valueFormatter: (params) => {
                return params != null ? params : '-'
            }
        },
    ]

    const handleDownloadCsv = () => {
        const header = ["Client ID", "Mobile No", "Last Traded Date", "Available Margin", "Portfolio PL", "Brokerage (FY)", "Call Date", "Call Description"]
        const data = engagementList.map(item => ({
            [header[0]]: item.client_id != null ? item.client_id : '',
            [header[1]]: item.mobileno != null ? item.mobileno : '',
            [header[2]]: item.lasttrade_date != null ? item.lasttrade_date : '',
            [header[3]]: item.available_margin != null ? Number(item.available_margin).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0,
            [header[4]]: item.profit_notional != null ? Number(item.profit_notional).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0,
            [header[5]]: item.total_net_brokerage != null ? Number(item.total_net_brokerage).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0,
            [header[6]]: item.lastcall_date != null ? item.lastcall_date : '',
            [header[7]]: item.lastcall_disp != null ? item.lastcall_disp : '',
        }))

        exportFromJSON({
            data,
            fileName: 'Client_Engagement_List1',
            exportType: exportFromJSON.types.csv
        })
    }

    return (
        <>
            <Grid container display="flex" justifyContent="flex-end" alignItems="center" sx={{ padding: '0 20px 0 0' }}>
                <Grid item>
                    <Button className={classes.btnDwnCsv} onClick={handleDownloadCsv}>
                        Download CSV
                    </Button>
                </Grid>
            </Grid>

            <Grid className={classes.horizantalTablayout} sx={{ marginTop: '20px' }}>
                <DataGrid
                    rows={engagementList}
                    columns={userColumns}
                    getRowId={(row) => row.client_id}
                    className={classes.customDataGrid}
                    style={{
                        '--DataGrid-containerBackground': '#131E2E',
                        '--DataGrid-rowBorderColor': '#000',
                        'border': 0,
                        width: '100% !important',
                    }}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 15 }
                        }
                    }}
                    pageSizeOptions={[10, 15, 25]}
                />
            </Grid>
        </>
    )
}

export default withStyles(styles)(ClientsList)